import { Box, Container, Typography, type TypographyProps, typographyClasses } from '@mui/material';
import { merge } from 'lodash';
import type { ReactNode } from 'react';
import { FontNormalSxProps } from '../../../_constants';

export interface AoaNoPermissionProps {
  /**
   * Additional props for the {@link Typography} component
   */
  readonly TypographyProps?: TypographyProps & { 'data-qa'?: string };
  /**
   * The 'no permission' message to display to the user
   */
  readonly children: ReactNode;
}

/**
 * Creates a 'no permission' message for unauthorized users
 *
 * @param props - Props to pass to the No Permission component
 * @example
 * ```jsx
 * <AoaNoPermission>
 *   This is a message
 * </AoaNoPermission>
 * ```
 */
export function AoaNoPermission({ children, TypographyProps }: AoaNoPermissionProps) {
  return (
    <Container maxWidth='md' sx={{ height: '100%' }}>
      <Box sx={{ height: '100%', placeContent: 'center center', display: 'flex', alignItems: 'center' }}>
        <Typography
          {...TypographyProps}
          color='textPrimary'
          sx={merge(
            {
              [`.${typographyClasses.root}`]: FontNormalSxProps
            },
            TypographyProps?.sx
          )}
          variant='h4'
        >
          {children}
        </Typography>
      </Box>
    </Container>
  );
}
